/* eslint-disable array-callback-return */
/* eslint-disable no-loop-func */
/* eslint-disable no-case-declarations */
import {useTranslation} from 'react-i18next';
import {createUseStyles, useTheme} from 'react-jss';
import {Classes} from 'jss';
import {TFunction} from 'i18next';
import {useObservers, useObserversFn} from '@utils/hooks/observers';
import SocketStore from '@utils/mobx/socket';

interface DecoratorDefine {
  withStyles?: any | {styles: any; hasProps: boolean; props: any};
  withTranslation?: string[];
  observers?: any;
  props?: any;
}

const useCommon = (
  define: DecoratorDefine
): {
  classes?: Classes<string>;
  // theme?: Object;
  theme?: any;
  t?: TFunction;
  socket?: SocketStore;
  // lobbySocket?: LobbySocketStore;
  [key: string]: any;
} => {
  let commonHooks: any = {};
  const {props} = define;
  for (const decorator of Object.keys(define)) {
    const element = define[decorator];
    switch (decorator) {
      case 'withStyles':
        if (element?.hasProps) {
          const useStyles = createUseStyles<string>(element.styles);
          const theme = useTheme();
          const classes = useStyles({...element.props, theme});
          commonHooks.classes = classes;
          commonHooks.theme = theme;
        } else {
          const useStyles = createUseStyles<string>(element);
          const theme = useTheme();
          const classes = useStyles({theme});
          commonHooks.classes = classes;
          commonHooks.theme = theme;
        }
        break;
      case 'withTranslation':
        const {t, i18n} = <Array<string>>element
          ? useTranslation(...(<Array<string>>element))
          : useTranslation();
        commonHooks.t = t;
        commonHooks.i18n = i18n;
        break;
      case 'observers':
        let observers = {};
        element.map(item => {
          switch (typeof item) {
            case 'string':
              observers = {
                ...observers,
                ...useObservers(item),
              };
              break;
            case 'function':
              observers = {
                ...observers,
                ...useObserversFn(item),
              };
              break;

            default:
              break;
          }
        });
        commonHooks = {
          ...commonHooks,
          ...observers,
        };

        break;
      default:
        break;
    }
  }
  return commonHooks;
};

export default useCommon;
